import { useState, useEffect } from "react";
import { useLocation, Route, Switch } from "wouter";
import { TendererLayout } from "@/components/tenderer/TendererLayout";
import { TendererDashboard } from "./TendererDashboard";
import { TendererPackages } from "./TendererPackages";
import { TendererReturns } from "./TendererReturns";
import { TendererMembers } from "./TendererMembers";

interface TendererAuth {
  email: string;
  accessCode: string;
  companyName: string;
  authenticatedAt: string;
}

export default function TendererMain() {
  const [location, setLocation] = useLocation();
  const [authData, setAuthData] = useState<TendererAuth | null>(null);

  useEffect(() => {
    const stored = sessionStorage.getItem('tendererAuth');
    if (stored) {
      try {
        const auth = JSON.parse(stored);
        setAuthData(auth);
        

      } catch (error) {
        console.error('Failed to parse auth data:', error);
        setLocation('/tenderer');
      }
    } else {
      setLocation('/tenderer');
    }
  }, [setLocation, location]);

  if (!authData) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <TendererLayout authData={authData}>
      <Switch>
        {/* New unified URL structure: /[tab]/:projectId/tenderer/:companyCode */}
        <Route path="/packages/:projectId/tenderer/:companyCode" component={() => <TendererPackages authData={authData} />} />
        <Route path="/returns/:projectId/tenderer/:companyCode" component={() => <TendererReturns authData={authData} />} />
        <Route path="/members/:projectId/tenderer/:companyCode" component={() => <TendererMembers authData={authData} />} />
        
        {/* Dashboard route */}
        <Route path="/dashboard/:projectId/tenderer/:companyCode" component={() => <TendererDashboard authData={authData} />} />
        
        {/* Default route */}
        <Route>
          <TendererDashboard authData={authData} />
        </Route>
      </Switch>
    </TendererLayout>
  );
}